/**
 * Typography Primitives — raw font values.
 */

export const fontFamily = {
  base: "Source Sans Pro",
  mono: "OfficeCodeProWeb, monospace",
} as const;

/** 9-step scale: xs(12) sm(13) base(14) lg(16) xl(18) 2xl(20) 3xl(24) 4xl(32) 5xl(40) */
export const fontSizeValues = {
  xs: "0.75rem",
  sm: "0.8125rem",
  base: "0.875rem",
  lg: "1rem",
  xl: "1.125rem",
  "2xl": "1.25rem",
  "3xl": "1.5rem",
  "4xl": "2rem",
  "5xl": "2.5rem",
} as const;

export const fontWeightValues = {
  light: "300",
  normal: "400",
  medium: "500",
  semibold: "600",
  bold: "700",
} as const;

export const lineHeightValues = {
  none: "1",
  compact: "1.1",
  tight: "1.2",
  snug: "1.3",
  normal: "1.5",
  relaxed: "1.6",
  loose: "1.75",
} as const;

export const letterSpacingValues = {
  none: "0",
  micro: "0.01em",
  tight: "0.02em",
  normal: "0.05em",
  caps: "0.08em",
  wide: "0.1em",
} as const;
